import React, { useCallback, useState } from "react";

import { getNumberComics, fetchInitialSnapshot, fetchNextSnapshot } from "../../../utils/databaseOperations";

import ComicItem from "../../../components/ComicItem";

// Load the spinner loading icon
import InfiniteScroll from "react-infinite-scroller/dist/InfiniteScroll";
import ClipLoader from "react-spinners/ClipLoader";




const Comics = ({togglePopup, urlPart}) => {

    // State variables for fetching comics from firestore
    const [docSnapshot, setDocSnapshot] = useState(null); 
    const [comicItems, setComicItems] = useState([]); 
    const [hasMoreComics, setHasMoreComics] = useState(true); 

    const [limitNumberComics, setLimitNumberComics] = useState(0); 
    const [initalLoading, setInitalLoading] = useState(true); 


    // Funcion para cargar comics cuando se haga scroll
    const fetchComics = useCallback(
        async () => {

            if(initalLoading){  // Si es la primera vez que carga comics entonces carga los prineros 3 comics

                let limit = await getNumberComics();
                let docSnapshots = await fetchInitialSnapshot(3);   // Cargar 3 comics
                let newComics = docSnapshots.docs.map(doc => doc.data());

        
                setLimitNumberComics(limit);
                setDocSnapshot(docSnapshots);
                setComicItems(comicItems.concat(newComics));
                setInitalLoading(false); // Indicar que ya no es la primera vez que carga comics

            }else{  // Si no es la primera vez, entonces carga los siguientes comics

                if(comicItems.length < limitNumberComics){  // Si el número de comics desplegados es menor al limite, entonces seguir cargando comics

                    let docSnapshots = await fetchNextSnapshot(docSnapshot, 2); // Cargar 2 comics cuando baje el scroll

                    let newComics = docSnapshots.docs.map(doc => doc.data());

                    setComicItems(comicItems.concat(newComics));
                    setDocSnapshot(docSnapshots);

                }else{  // Si no, entonces dejar de cargar comics
                    setHasMoreComics(false);
                }
            }
        },
        [comicItems, docSnapshot, initalLoading]
    );



    // Return several comics distributed between pages (which will be loaded when scroll reach bottom value)
    return (
        <InfiniteScroll
        pageStart={1}
        loadMore={fetchComics}
        hasMore={hasMoreComics}
        loader={<ClipLoader
                color={"#2688ff"}
                loading={true}
                cssOverride={{
                    display: "block",
                    margin: "75px auto",
                    borderColor: "blue",
                }}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
            />}
        >
 
            <section className="flex items-center flex-col max-w-4xl mx-auto py-4 gap-y-7">
                {comicItems.map((item) => (
                    <ComicItem key={item.id} item={item} togglePopup={togglePopup} urlPart={urlPart}/>
                ))}
            </section>

        </InfiniteScroll>
    ); 
}; 

export default Comics; 